import { defineMessages } from "react-intl";

const messages = defineMessages({
  addStage: {
    id: "deals.setting.funnel.stage.addStage",
    defaultMessage: "+ Add Stage",
    description: "Add stage button in a funnel",
  },
  color: {
    id: "deals.settings.funnels.color.title",
    defaultMessage: "Color",
    description: "Color column title",
  },
  label: {
    id: "deals.settings.funnels.rottingAt.label",
    defaultMessage: "Rotting At",
    description: "rottingAt label",
  },
  probability: {
    id: "deals.settings.funnels.probability.title",
    defaultMessage: "Probability",
    description: "Probability column title",
  },
  rottingAt: {
    id: "deals.settings.funnels.rottingAt.tooltip",
    defaultMessage:
      "Set a rot limit for this stage to be made aware when a deal has been sitting in a stage for too long",
    description: "rottingAt tooltip",
  },
  subtitle: {
    id: "deals.setting.funnel.collapse.subtitle",
    defaultMessage: "{count} {count, plural, one {Stage} other {Stages}}",
    description: "funnel stages subtitle",
  },
  title: {
    id: "deals.settings.funnels.name.title",
    defaultMessage: "Name",
    description: "Name column title",
  },
  tooltip: {
    id: "deals.settings.funnels.dropZone.tooltip",
    defaultMessage: "Click, hold and drag the grip icon to change stage order",
    description: "drag and drop tooltip",
  },
});

export default messages;
